module.exports = __webpack_public_path__ + "static/media/Nepal - NP.f7beb566.png";